import { incompatibilityAnalysisActions } from '../actions'

const {
  FETCHING_CABINETS,
  FETCH_CABINETS,
  FETCH_CABINETS_ERROR,
  ADDING_CABINET,
  ADD_CABINET,
  ADD_CABINET_ERROR,
  REMOVING_CABINET,
  REMOVE_CABINET,
  REMOVE_CABINET_ERROR,
  SEARCHING_CABINET,
  SEARCH_CABINET,
  SEARCH_CABINET_ERROR,
  REMOVING_CABINET_PRODUCT,
  REMOVE_CABINET_PRODUCT,
  REMOVE_CABINET_PRODUCT_ERROR,
  ADDING_CABINET_PRODUCT,
  ADD_CABINET_PRODUCT,
  ADD_CABINET_PRODUCT_ERROR,
  CHANGE_SELECT_INPUT,
  CHANGE_LAST_UPDATE,
  UPDATING_CABINET,
  UPDATE_CABINET,
  UPDATE_CABINET_ERROR,
  FETCH_DOWNLOAD_PDF,
  FETCHING_DOWNLOAD_PDF,
  FETCH_DOWNLOAD_PDF_ERROR,
  CHANGE_STATUS_DOWNLOAD_ERROR,
  FETCHING_QRCODE,
  FETCH_QRCODE,
  FETCH_QRCODE_ERROR
} = incompatibilityAnalysisActions

const initialState = {
  loading: {
    cabinets: false,
    cabinet: false,
    download: false,
    qr_code: false
  },
  fetch_errors: {
    cabinets: false,
    download: false,
    qr_code: false
  },
  cabinets: [],
  last_update: undefined,
  total_records: undefined,
  modalOpen: false
}

const incompatibilityAnalysis = (state = initialState, action = '') => {
  switch (action.type) {
    case ADDING_CABINET:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case ADD_CABINET:
      return {
        ...state,
        cabinets: [...state.cabinets, action.cabinet],
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case ADD_CABINET_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: false
        }
      }

    case UPDATING_CABINET:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case UPDATE_CABINET:
      return {
        ...state,
        cabinets: state.cabinets.map(
          cabinet => (cabinet.id === action.cabinet.id ? action.cabinet : cabinet)
        ),
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case UPDATE_CABINET_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: false
        }
      }

    case REMOVING_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        },
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case REMOVE_CABINET:
      return {
        ...state,
        cabinets: state.cabinets.filter(item => {
          return item.id !== action.cabinetId
        }),
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case REMOVE_CABINET_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: true
        },
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case FETCHING_CABINETS:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinets: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case FETCH_CABINETS:
      return {
        ...state,
        cabinets: action.cabinets,
        last_update: action.last_update,
        loading: {
          ...state.loading,
          cabinets: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case FETCH_CABINETS_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinets: false
        },
        fetch_errors: {
          cabinets: true
        }
      }

    case SEARCHING_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: false
        }
      }

    case SEARCH_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: false
        }
      }

    case SEARCH_CABINET_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: true
        }
      }

    case ADDING_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case ADD_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.cabinet_products.push(action.product)
            cabinet.inputValue = ''
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case ADD_CABINET_PRODUCT_ERROR:
      return {
        ...state
      }

    case REMOVING_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case REMOVE_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            const products = cabinet.cabinet_products.filter(product => {
              return product.id !== action.productId
            })

            cabinet.cabinet_products = products
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case REMOVE_CABINET_PRODUCT_ERROR:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case CHANGE_SELECT_INPUT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.inputValue = action.value
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case CHANGE_LAST_UPDATE:
      return {
        ...state,
        last_update: new Date().toISOString()
      }

    case FETCHING_DOWNLOAD_PDF:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: true
        }
      }

    case FETCH_DOWNLOAD_PDF:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: false
        }
      }

    case FETCH_DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: true
        }
      }

    case CHANGE_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case FETCHING_QRCODE:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: false
        }
      }

    case FETCH_QRCODE:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: false
        }
      }

    case FETCH_QRCODE_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: true
        }
      }

    default:
      return state
  }
}

export default incompatibilityAnalysis



// WEBPACK FOOTER //
// ./src/reducers/incompatibilityAnalysis.js